import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { getStoreResource, setStoreResource } from '@/utils/store';
import React from 'react';
import { Schedule } from '../Schedule';
import { Properties } from './Content/Properties';

export default function EditAlarm ({ modelData }) {
    const alarm = modelData;
    const indicator = getStoreResource('indicators', alarm.indicator_id);

    const initialData = {
        active: modelData?.active || false,
        indicatorId: alarm.indicator_id || '',
        maxValue: indicator?.unit === 'Wh' ? modelData?.max_value / 1000 :  modelData?.max_value || 0,
        minValue: indicator?.unit === 'Wh' ? modelData?.min_value / 1000 : modelData?.min_value || 0,
        name: modelData?.name || '',
        schedule: modelData?.schedule || {},
        userIds: modelData?.user_ids || []
    };

    const steps = [
        { Component: Properties, title: i18next.t('modal.title.alarms.edit') },
        { Component: Schedule, title: i18next.t('modal.title.alarm_schedules.edit') }
    ];

    const handleSubmit = async data => {
        if (indicator.unit === 'Wh')        {
            data.minValue = data.minValue * 1000;
            data.maxValue = data.maxValue * 1000;
        }

        return await setStoreResource('alarms', {
            ...data,
            id: alarm.id
        });
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
